import { render, staticRenderFns } from "./ProcessBase.vue?vue&type=template&id=59c89f4c&"
import script from "./ProcessBase.vue?vue&type=script&lang=js&"
export * from "./ProcessBase.vue?vue&type=script&lang=js&"
import style0 from "./ProcessBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports